interface AppConfig {
  baseUrl: string;
  authority: string;
  clientId: string;
  clientSecret: string;
  postLogoutRedirectUri: string;
  redirectUri: string;
}

const config: AppConfig = {
  baseUrl: window.REACT_APP_API_BASE_URI as string,
  authority: window.REACT_APP_OIDC_AUTHORITY as string,
  clientId: window.REACT_APP_OIDC_CLIENT_ID as string,
  clientSecret: window.REACT_APP_OIDC_CLIENT_SECRET as string,
  postLogoutRedirectUri: window.REACT_APP_OIDC_REDIRECT_URI as string,
  redirectUri: window.REACT_APP_OIDC_REDIRECT_URI as string
};

export default config;
